
interface QuotationAmountProps {
  amount: number;
}

export function QuotationAmount({ amount }: QuotationAmountProps) {
  // Garantir que o valor seja um número
  const safeAmount = typeof amount === 'number' ? amount : 0;
  
  return (
    <span className="text-nowrap font-medium text-[#0073B7]">
      {new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(safeAmount)}
    </span>
  );
}
